export const rrActivityOccConfig = {
  backend: {
    occ: {
      endpoints: {
        activity: '/users/${userId}/activity',
      },
    },
  },
};
